import { Dialog, IconName, Intent } from '@blueprintjs/core'
import React, { Component } from 'react'
import { TranslationFunction } from 'react-i18next'

import { ReactNode } from 'react-redux'
import { i18nKeys } from '../../../app.i18n'
import { Button, identity } from '../../../shared'

type Props = {
  isOpen: boolean
  icon?: IconName
  titleText: string
  bodyText: string | ReactNode
  translate?: TranslationFunction
  disabledBtn?: boolean
  translateOkBtn?: string
  onConfirm(event?: React.MouseEvent<HTMLElement>): void
  onClose(): void
}

export class ConfirmDialog extends Component<Props> {
  render() {
    const {
      translate = identity,
      bodyText,
      isOpen,
      titleText,
      icon = 'inbox',
      disabledBtn = false,
      translateOkBtn,
    } = this.props
    // const bodyTextDefault = bodyText || translate(i18nKeys.frontFace.shared.discardDialog.defaultBodyText)

    return (
      <Dialog
        icon={icon}
        isOpen={isOpen}
        onClose={this.handleClose}
        title={titleText} // translate(i18nKeys.frontFace.shared.discardDialog.title)
      >
        <div className="bp3-dialog-body">{bodyText}</div>
        <div className="bp3-dialog-footer">
          <div className="bp3-dialog-footer-actions">
            <Button intent={Intent.PRIMARY} onClick={this.handleConfirm} disabled={disabledBtn}>
              {translateOkBtn ? translate(translateOkBtn) : translate(i18nKeys.core.common.ok)}
            </Button>
            <Button onClick={this.handleClose}>{translate(i18nKeys.core.common.cancel)}</Button>
          </div>
        </div>
      </Dialog>
    )
  }

  private handleConfirm = () => {
    this.props.onConfirm()
  }

  private handleClose = () => {
    this.props.onClose()
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/confirm-dialog/confirm-dialog.tsx